export const searchQueryFilter = (searchQuery) => (object) => {
  return Object.values(object).some(
    (field) => field && String(field).toLowerCase().indexOf(searchQuery.toLowerCase()) > -1
  );
};

export const tagFilter = (selectedTags) => (object) => {
  if (selectedTags.length > 0) {
    let noMatch = true;
    for (let i = 0; i < selectedTags.length; i++) {
      if (!object.keywords.find((t) => t === selectedTags[i])) {
        noMatch = false;
        break;
      }
    }
    return noMatch;
  }

  return true;
};

export const ratingFilter = (selectedRating) => (object) =>
  selectedRating ? object.averageRating >= selectedRating : true;
